import Vue__default from "vue";
import TUIMessageBox from "./index.vue.mjs";
const MessageBox = ({
  title,
  message,
  callback,
  duration,
  cancelButtonText,
  confirmButtonText
}) => {
  const container = document.createElement("div");
  const fullscreenElement = document.fullscreenElement || document.getElementById("roomContainer") || document.getElementById("pre-conference-container");
  if (!fullscreenElement) return;
  fullscreenElement.appendChild(container);
  const onRemove = () => {
    vm.$destroy();
    fullscreenElement.removeChild(container);
  };
  const MessageBoxConstruct = Vue__default.extend({
    render: (h) => h(TUIMessageBox, {
      props: {
        title,
        message,
        callback,
        duration,
        cancelButtonText,
        confirmButtonText,
        remove: onRemove
      }
    })
  });
  const vm = new MessageBoxConstruct({
    el: document.createElement("div")
  }).$mount();
  container.appendChild(vm.$el);
};
export {
  MessageBox as default
};
